// components/stickerData.js

const sources = {
  loaderDots: require("../assets/lotties/loaderdots.json"),
  loveLegacy: require("../assets/lotties/animated-heart.json"),
  furiousLegacy: require("../assets/lotties/danger-angry-cactus.json"),
  neutralLegacy: require("../assets/lotties/neutral.json"),

  // Expressions
  angel: require("../assets/lotties/animatedemojis/angel.json"),
  angry: require("../assets/lotties/animatedemojis/angry.json"),
  blush: require("../assets/lotties/animatedemojis/blush.json"),
  chill: require("../assets/lotties/animatedemojis/chill.json"),
  cold: require("../assets/lotties/animatedemojis/cold.json"),
  cool: require("../assets/lotties/animatedemojis/cool.json"),
  crying: require("../assets/lotties/animatedemojis/crying.json"),
  crying1: require("../assets/lotties/animatedemojis/crying1.json"),
  dead: require("../assets/lotties/animatedemojis/dead.json"),
  devil: require("../assets/lotties/animatedemojis/devil.json"),
  dizzy: require("../assets/lotties/animatedemojis/dizzy.json"),
  famous: require("../assets/lotties/animatedemojis/famous.json"),
  greed: require("../assets/lotties/animatedemojis/greed.json"),
  grimacing: require("../assets/lotties/animatedemojis/grimacing.json"),
  happy: require("../assets/lotties/animatedemojis/happy.json"),
  happy1: require("../assets/lotties/animatedemojis/happy1.json"),
  injured: require("../assets/lotties/animatedemojis/injured.json"),
  inlove: require("../assets/lotties/animatedemojis/inlove.json"),
  king: require("../assets/lotties/animatedemojis/king.json"),
  kiss: require("../assets/lotties/animatedemojis/kiss.json"),
  laughing: require("../assets/lotties/animatedemojis/laughing.json"),
  mad: require("../assets/lotties/animatedemojis/mad.json"),
  nausea: require("../assets/lotties/animatedemojis/nausea.json"),
  nerd: require("../assets/lotties/animatedemojis/nerd.json"),
  neutral: require("../assets/lotties/animatedemojis/neutral.json"),
  ninja: require("../assets/lotties/animatedemojis/ninja.json"),
  notalk: require("../assets/lotties/animatedemojis/notalk.json"),
  party: require("../assets/lotties/animatedemojis/party.json"),
  sad: require("../assets/lotties/animatedemojis/sad.json"),
  secret: require("../assets/lotties/animatedemojis/secret.json"),
  shock: require("../assets/lotties/animatedemojis/shock.json"),
  sick: require("../assets/lotties/animatedemojis/sick.json"),
  sick1: require("../assets/lotties/animatedemojis/sick1.json"),
  sleeping: require("../assets/lotties/animatedemojis/sleeping.json"),
  smiling: require("../assets/lotties/animatedemojis/smiling.json"),
  smiling1: require("../assets/lotties/animatedemojis/smiling1.json"),
  smiling2: require("../assets/lotties/animatedemojis/smiling2.json"),
  sneezing: require("../assets/lotties/animatedemojis/sneezing.json"),
  surprise: require("../assets/lotties/animatedemojis/surprise.json"),
  sweat: require("../assets/lotties/animatedemojis/sweat.json"),
  thief: require("../assets/lotties/animatedemojis/thief.json"),
  thinking: require("../assets/lotties/animatedemojis/thinking.json"),
  tongue: require("../assets/lotties/animatedemojis/tongue.json"),
  vampire: require("../assets/lotties/animatedemojis/vampire.json"),
  vomiting: require("../assets/lotties/animatedemojis/vomiting.json"),
  whistle: require("../assets/lotties/animatedemojis/whistle.json"),
  winking: require("../assets/lotties/animatedemojis/winking.json"),
  yawning: require("../assets/lotties/animatedemojis/yawning.json"),
  zombie: require("../assets/lotties/animatedemojis/zombie.json"),

  // Business
  announce: require("../assets/lotties/business/announce.json"),
  contract: require("../assets/lotties/business/contract.json"),
  flexible: require("../assets/lotties/business/flexible.json"),
  office: require("../assets/lotties/business/office.json"),
  partner: require("../assets/lotties/business/partner.json"),
  planning: require("../assets/lotties/business/planning.json"),
  presentation: require("../assets/lotties/business/presentation.json"),
  startup: require("../assets/lotties/business/startup.json"),

  // Cleaning
  apartmentcleaning: require("../assets/lotties/cleaning/apartmentcleaning.json"),
  bookacleaner: require("../assets/lotties/cleaning/bookacleaner.json"),
  furniturecleaning: require("../assets/lotties/cleaning/furniturecleaning.json"),
  maid: require("../assets/lotties/cleaning/maid.json"),
  mop: require("../assets/lotties/cleaning/mop.json"),
  vacuumcleaner: require("../assets/lotties/cleaning/vacuumcleaner.json"),
  windowcleaning: require("../assets/lotties/cleaning/windowcleaning.json"),
  wipe: require("../assets/lotties/cleaning/wipe.json"),

  // Ecommerce
  baskettrolley: require("../assets/lotties/ecommerce/baskettrolley.json"),
  bitcoinpricetag: require("../assets/lotties/ecommerce/bitcoinpricetag.json"),
  deliver: require("../assets/lotties/ecommerce/deliver.json"),
  discount: require("../assets/lotties/ecommerce/discount.json"),
  dollarpricetag: require("../assets/lotties/ecommerce/dollarpricetag.json"),
  europricetag: require("../assets/lotties/ecommerce/europricetag.json"),
  expressdelivery: require("../assets/lotties/ecommerce/expressdelivery.json"),
  faq: require("../assets/lotties/ecommerce/faq.json"),
  free: require("../assets/lotties/ecommerce/free.json"),
  free1: require("../assets/lotties/ecommerce/free1.json"),
  moneybag: require("../assets/lotties/ecommerce/moneybag.json"),
  sale: require("../assets/lotties/ecommerce/sale.json"),

  // Education
  apple: require("../assets/lotties/education/apple.json"),
  bell: require("../assets/lotties/education/bell.json"),
  checklist: require("../assets/lotties/education/checklist.json"),
  graduationhat: require("../assets/lotties/education/graduationhat.json"),
  idea: require("../assets/lotties/education/idea.json"),
  schoolbus: require("../assets/lotties/education/schoolbus.json"),
  studylamp: require("../assets/lotties/education/studylamp.json"),

  // Food and drinks
  aeropresscoffee: require("../assets/lotties/foodanddrinks/aeropresscoffee.json"),
  avocado: require("../assets/lotties/foodanddrinks/avocado.json"),
  banana: require("../assets/lotties/foodanddrinks/banana.json"),
  bread: require("../assets/lotties/foodanddrinks/bread.json"),
  coffee: require("../assets/lotties/foodanddrinks/coffee.json"),
  greentea: require("../assets/lotties/foodanddrinks/greentea.json"),

  // Marketing
  analysis: require("../assets/lotties/marketing/analysis.json"),
  calendar: require("../assets/lotties/marketing/calendar.json"),
  goal: require("../assets/lotties/marketing/goal.json"),
  graphup: require("../assets/lotties/marketing/graphup.json"),

  // Online education
  backtoschool: require("../assets/lotties/onlineeducation/backtoschool.json"),
  economiceducation: require("../assets/lotties/onlineeducation/economiceducation.json"),
  globaleducation: require("../assets/lotties/onlineeducation/globaleducation.json"),
  investmentineducation: require("../assets/lotties/onlineeducation/investmentineducation.json"),
  livewebinar: require("../assets/lotties/onlineeducation/livewebinar.json"),
  onlinecourse: require("../assets/lotties/onlineeducation/onlinecourse.json"),
  onlinecourse1: require("../assets/lotties/onlineeducation/onlinecourse1.json"),
  onlinetests: require("../assets/lotties/onlineeducation/onlinetests.json"),
  questionsandanswers: require("../assets/lotties/onlineeducation/questionsandanswers.json"),
  searchofknowledge: require("../assets/lotties/onlineeducation/searchofknowledge.json"),
  sharingideas: require("../assets/lotties/onlineeducation/sharingideas.json"),

  // Travel
  airplane: require("../assets/lotties/travelandtourism/airplane.json"),
  bathtub: require("../assets/lotties/travelandtourism/bathtub.json"),
  boat: require("../assets/lotties/travelandtourism/boat.json"),
  camping: require("../assets/lotties/travelandtourism/camping.json"),
  cocktail: require("../assets/lotties/travelandtourism/cocktail.json"),
  divingmask: require("../assets/lotties/travelandtourism/divingmask.json"),
  passport: require("../assets/lotties/travelandtourism/passport.json"),
  weather: require("../assets/lotties/travelandtourism/weather.json"),

  // Web development
  blogcommenting: require("../assets/lotties/webdevelopment/blogcommenting.json"),
  brainstorming: require("../assets/lotties/webdevelopment/brainstorming.json"),
  customcoding: require("../assets/lotties/webdevelopment/customcoding.json"),
  customersupport: require("../assets/lotties/webdevelopment/customersupport.json"),
  designservice: require("../assets/lotties/webdevelopment/designservice.json"),
  domainregistration: require("../assets/lotties/webdevelopment/domainregistration.json"),
  emailmarketing: require("../assets/lotties/webdevelopment/emailmarketing.json"),
  globalsearch: require("../assets/lotties/webdevelopment/globalsearch.json"),
  localbusiness: require("../assets/lotties/webdevelopment/localbusiness.json"),
  mobileapplication: require("../assets/lotties/webdevelopment/mobileapplication.json"),
  seoconsulting: require("../assets/lotties/webdevelopment/seoconsulting.json"),
};

export const STICKER_CATEGORIES = [
  { key: "expressions", label: "Expressions" },
  { key: "work", label: "Work" },
  { key: "learning", label: "Learning" },
  { key: "shopping", label: "Shopping" },
  { key: "food", label: "Food & Drink" },
  { key: "travel", label: "Travel" },
  { key: "cleaning", label: "Cleaning" },
];

const timedSticker = (source, category, options = {}) => ({
  source,
  category,
  background: "#F5F5F5",
  size: 0.7,
  offsetX: 0,
  offsetY: 0,
  rotation: 0,
  delay: 500,
  fadeIn: 700,
  duration: 3000,
  fadeOut: 700,
  wait: 3000,
  loop: false,
  hidePeep: false,
  selectable: true,
  ...options,
});

const fullSticker = (source, category, options = {}) => ({
  source,
  category,
  background: "#F5F5F5",
  size: 0.85,
  offsetX: 0,
  offsetY: 0,
  rotation: 0,
  loop: true,
  hidePeep: true,
  selectable: true,
  ...options,
});

const rawStickers = {
  // Expressions
  angel: timedSticker(sources.angel, "expressions"),
  angry: timedSticker(sources.angry, "expressions", {
    avatar: { face: "VeryAngry" },
  }),
  blush: timedSticker(sources.blush, "expressions"),
  chill: timedSticker(sources.chill, "expressions"),
  cold: timedSticker(sources.cold, "expressions"),
  cool: timedSticker(sources.cool, "expressions"),
  crying: timedSticker(sources.crying, "expressions"),
  crying1: timedSticker(sources.crying1, "expressions", {
    label: "Crying 2",
  }),
  dead: timedSticker(sources.dead, "expressions"),
  devil: timedSticker(sources.devil, "expressions"),
  dizzy: timedSticker(sources.dizzy, "expressions"),
  famous: timedSticker(sources.famous, "expressions"),
  greed: timedSticker(sources.greed, "expressions"),
  grimacing: timedSticker(sources.grimacing, "expressions"),
  happy: timedSticker(sources.happy, "expressions", {
    avatar: { face: "Cute" },
  }),
  happy1: timedSticker(sources.happy1, "expressions", {
    label: "Happy 2",
  }),
  injured: timedSticker(sources.injured, "expressions"),
  inlove: timedSticker(sources.inlove, "expressions", {
    label: "In love",
    keywords: ["love", "heart", "romance"],
  }),
  king: timedSticker(sources.king, "expressions"),
  kiss: timedSticker(sources.kiss, "expressions"),
  laughing: timedSticker(sources.laughing, "expressions", {
    keywords: ["laugh", "lol", "funny"],
  }),
  mad: timedSticker(sources.mad, "expressions"),
  nausea: timedSticker(sources.nausea, "expressions"),
  nerd: timedSticker(sources.nerd, "expressions"),
  neutral: timedSticker(sources.neutral, "expressions"),
  ninja: timedSticker(sources.ninja, "expressions"),
  notalk: timedSticker(sources.notalk, "expressions", {
    label: "No talking",
    keywords: ["quiet", "silent", "secret"],
  }),
  party: timedSticker(sources.party, "expressions"),
  sad: timedSticker(sources.sad, "expressions", {
    avatar: { face: "Solemn" },
  }),
  secret: timedSticker(sources.secret, "expressions"),
  shock: timedSticker(sources.shock, "expressions"),
  sick: timedSticker(sources.sick, "expressions"),
  sick1: timedSticker(sources.sick1, "expressions", {
    label: "Sick 2",
  }),
  sleeping: timedSticker(sources.sleeping, "expressions"),
  smiling: timedSticker(sources.smiling, "expressions"),
  smiling1: timedSticker(sources.smiling1, "expressions", {
    label: "Smiling 2",
  }),
  smiling2: timedSticker(sources.smiling2, "expressions", {
    label: "Smiling 3",
  }),
  sneezing: timedSticker(sources.sneezing, "expressions"),
  surprise: timedSticker(sources.surprise, "expressions"),
  sweat: timedSticker(sources.sweat, "expressions"),
  thief: timedSticker(sources.thief, "expressions"),
  thinking: timedSticker(sources.thinking, "expressions"),
  tongue: timedSticker(sources.tongue, "expressions"),
  vampire: timedSticker(sources.vampire, "expressions"),
  vomiting: timedSticker(sources.vomiting, "expressions"),
  whistle: timedSticker(sources.whistle, "expressions"),
  winking: timedSticker(sources.winking, "expressions"),
  yawning: timedSticker(sources.yawning, "expressions"),
  zombie: timedSticker(sources.zombie, "expressions"),

  // Work: business, marketing and web development
  announce: fullSticker(sources.announce, "work"),
  contract: fullSticker(sources.contract, "work"),
  flexible: fullSticker(sources.flexible, "work"),
  office: fullSticker(sources.office, "work"),
  partner: fullSticker(sources.partner, "work"),
  planning: fullSticker(sources.planning, "work"),
  presentation: fullSticker(sources.presentation, "work"),
  startup: fullSticker(sources.startup, "work"),
  analysis: fullSticker(sources.analysis, "work"),
  calendar: fullSticker(sources.calendar, "work"),
  goal: fullSticker(sources.goal, "work"),
  graphup: fullSticker(sources.graphup, "work", {
    label: "Growth graph",
    keywords: ["chart", "growth", "analytics"],
  }),
  blogcommenting: fullSticker(sources.blogcommenting, "work", {
    label: "Blog commenting",
  }),
  brainstorming: fullSticker(sources.brainstorming, "work"),
  customcoding: fullSticker(sources.customcoding, "work", {
    label: "Custom coding",
  }),
  customersupport: fullSticker(sources.customersupport, "work", {
    label: "Customer support",
  }),
  designservice: fullSticker(sources.designservice, "work", {
    label: "Design service",
  }),
  domainregistration: fullSticker(sources.domainregistration, "work", {
    label: "Domain registration",
  }),
  emailmarketing: fullSticker(sources.emailmarketing, "work", {
    label: "Email marketing",
  }),
  globalsearch: fullSticker(sources.globalsearch, "work", {
    label: "Global search",
  }),
  localbusiness: fullSticker(sources.localbusiness, "work", {
    label: "Local business",
  }),
  mobileapplication: fullSticker(sources.mobileapplication, "work", {
    label: "Mobile application",
  }),
  seoconsulting: fullSticker(sources.seoconsulting, "work", {
    label: "SEO consulting",
  }),

  // Learning: education and online education
  apple: fullSticker(sources.apple, "learning"),
  bell: fullSticker(sources.bell, "learning"),
  checklist: fullSticker(sources.checklist, "learning"),
  graduationhat: fullSticker(sources.graduationhat, "learning", {
    label: "Graduation hat",
  }),
  idea: fullSticker(sources.idea, "learning"),
  schoolbus: fullSticker(sources.schoolbus, "learning", {
    label: "School bus",
  }),
  studylamp: fullSticker(sources.studylamp, "learning", {
    label: "Study lamp",
  }),
  backtoschool: fullSticker(sources.backtoschool, "learning", {
    label: "Back to school",
  }),
  economiceducation: fullSticker(sources.economiceducation, "learning", {
    label: "Economic education",
  }),
  globaleducation: fullSticker(sources.globaleducation, "learning", {
    label: "Global education",
  }),
  investmentineducation: fullSticker(
    sources.investmentineducation,
    "learning",
    { label: "Education investment" },
  ),
  livewebinar: fullSticker(sources.livewebinar, "learning", {
    label: "Live webinar",
  }),
  onlinecourse: fullSticker(sources.onlinecourse, "learning", {
    label: "Online course",
  }),
  onlinecourse1: fullSticker(sources.onlinecourse1, "learning", {
    label: "Online course 2",
  }),
  onlinetests: fullSticker(sources.onlinetests, "learning", {
    label: "Online tests",
  }),
  questionsandanswers: fullSticker(
    sources.questionsandanswers,
    "learning",
    { label: "Questions and answers" },
  ),
  searchofknowledge: fullSticker(sources.searchofknowledge, "learning", {
    label: "Search for knowledge",
  }),
  sharingideas: fullSticker(sources.sharingideas, "learning", {
    label: "Sharing ideas",
  }),

  // Shopping
  baskettrolley: fullSticker(sources.baskettrolley, "shopping", {
    label: "Shopping trolley",
  }),
  bitcoinpricetag: fullSticker(sources.bitcoinpricetag, "shopping", {
    label: "Bitcoin price tag",
  }),
  deliver: fullSticker(sources.deliver, "shopping"),
  discount: fullSticker(sources.discount, "shopping"),
  dollarpricetag: fullSticker(sources.dollarpricetag, "shopping", {
    label: "Dollar price tag",
  }),
  europricetag: fullSticker(sources.europricetag, "shopping", {
    label: "Euro price tag",
  }),
  expressdelivery: fullSticker(sources.expressdelivery, "shopping", {
    label: "Express delivery",
  }),
  faq: fullSticker(sources.faq, "shopping", {
    label: "FAQ",
  }),
  free: fullSticker(sources.free, "shopping"),
  free1: fullSticker(sources.free1, "shopping", {
    label: "Free 2",
  }),
  moneybag: fullSticker(sources.moneybag, "shopping", {
    label: "Money bag",
  }),
  sale: fullSticker(sources.sale, "shopping"),

  // Food and drink
  aeropresscoffee: fullSticker(sources.aeropresscoffee, "food", {
    label: "AeroPress coffee",
  }),
  avocado: fullSticker(sources.avocado, "food"),
  banana: fullSticker(sources.banana, "food"),
  bread: fullSticker(sources.bread, "food"),
  coffee: fullSticker(sources.coffee, "food"),
  greentea: fullSticker(sources.greentea, "food", {
    label: "Green tea",
  }),

  // Travel
  airplane: fullSticker(sources.airplane, "travel"),
  bathtub: fullSticker(sources.bathtub, "travel"),
  boat: fullSticker(sources.boat, "travel"),
  camping: fullSticker(sources.camping, "travel"),
  cocktail: fullSticker(sources.cocktail, "travel"),
  divingmask: fullSticker(sources.divingmask, "travel", {
    label: "Diving mask",
  }),
  passport: fullSticker(sources.passport, "travel"),
  weather: fullSticker(sources.weather, "travel"),

  // Cleaning
  apartmentcleaning: fullSticker(sources.apartmentcleaning, "cleaning", {
    label: "Apartment cleaning",
  }),
  bookacleaner: fullSticker(sources.bookacleaner, "cleaning", {
    label: "Book a cleaner",
  }),
  furniturecleaning: fullSticker(sources.furniturecleaning, "cleaning", {
    label: "Furniture cleaning",
  }),
  maid: fullSticker(sources.maid, "cleaning"),
  mop: fullSticker(sources.mop, "cleaning"),
  vacuumcleaner: fullSticker(sources.vacuumcleaner, "cleaning", {
    label: "Vacuum cleaner",
  }),
  windowcleaning: fullSticker(sources.windowcleaning, "cleaning", {
    label: "Window cleaning",
  }),
  wipe: fullSticker(sources.wipe, "cleaning"),

  // Older keys remain renderable for existing messages, but are hidden
  // from the current picker.
  love: timedSticker(sources.loveLegacy, "expressions", {
    selectable: false,
    size: 0.5,
    offsetX: -5,
    offsetY: 40,
    rotation: -10,
    avatar: { face: "LovingGrin1" },
  }),
  furious: timedSticker(sources.furiousLegacy, "expressions", {
    selectable: false,
    size: 1.4,
    offsetX: -30,
    offsetY: 20,
    rotation: -10,
    avatar: { face: "Rage" },
  }),
  smile: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "Smile" },
  }),
  extrahappy: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "SmileBig" },
  }),
  surprised: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "ExplainingFace" },
  }),
  huh: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "Suspicious" },
  }),
  wtf: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "Serious" },
  }),
  workin: timedSticker(sources.loaderDots, "work", {
    selectable: false,
    avatar: { face: "EyesClosed", body: "Macbook" },
  }),
  iknow: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "Contempt" },
  }),
  tellmeboutit: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "SmileLOL" },
  }),
  noidea: timedSticker(sources.neutralLegacy, "expressions", {
    selectable: false,
    size: 0.6,
    avatar: { face: "ConcernedFear" },
  }),
  warmdrink: timedSticker(sources.loaderDots, "food", {
    selectable: false,
    avatar: { body: "Coffee" },
  }),
  cunny: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "Driven" },
  }),
  panicked: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "Concerned" },
  }),
  scared: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "Fear" },
  }),
  hectic: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "Hectic" },
  }),
  frustrated: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "Tired" },
  }),
  youdidit: timedSticker(sources.loaderDots, "expressions", {
    selectable: false,
    avatar: { face: "Cheeky" },
  }),
};

const makeDefaultLabel = (key) =>
  key
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/(\D)(\d+)$/, "$1 $2")
    .replace(/^./, (character) => character.toUpperCase());

export const STICKERS = Object.fromEntries(
  Object.entries(rawStickers).map(([key, sticker]) => [
    key,
    {
      key,
      ...sticker,
      label: sticker.label || makeDefaultLabel(key),
      keywords: sticker.keywords || [],
      avatar: sticker.avatar || {},
    },
  ]),
);

export const STICKER_KEYS = Object.keys(STICKERS).filter(
  (key) => STICKERS[key].selectable !== false,
);

export const getSticker = (key) => STICKERS[key] || null;